const EMAIL_SHARE_URL = 'https://opn.so/ShareApp-Email';
const TWITTER_SHARE_URL = 'https://opn.so/ShareApp-TW';
export {EMAIL_SHARE_URL,TWITTER_SHARE_URL}